module.exports = "/images/closeGrey.svg";